"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Actions = void 0;
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _useTranslations = require("../../../../hooks/useTranslations");
var _utils = require("../../../../utils");
var _FacetFilter = require("../../../FacetFilter");
var _FiltersContainer = require("../../../FiltersContainer");
var _Sorting = require("../../../Sorting");
var _useFilter = require("../../utils/useFilter");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Actions = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { headers } = (0, _presentationHttp.useHeaders)();
    const { data, pageId, appliedFacets, orderBy, setAppliedFacets, setOrderBy, enableFetch, isRefreshing } = (0, _contexts.useBannerProductListingContext)();
    const isMobile = (0, _presentationHooks.useIsMobile)();
    const { translations } = (0, _useTranslations.useTranslations)();
    var _data_facets_length;
    const hasInitialFacets = ((_data_facets_length = data === null || data === void 0 ? void 0 : data.facets.length) !== null && _data_facets_length !== void 0 ? _data_facets_length : 0) > 0;
    const mappedOrderByOptions = (0, _react.useMemo)(()=>(0, _utils.mapOrderByFromApi)(data === null || data === void 0 ? void 0 : data.orderByOptions), [
        data === null || data === void 0 ? void 0 : data.orderByOptions
    ]);
    const loadDataFromFilter = (0, _react.useCallback)(()=>{
        enableFetch();
    }, [
        enableFetch
    ]);
    const onSort = (0, _react.useCallback)(async (orderByValue)=>{
        await setOrderBy(orderByValue);
        enableFetch();
    }, [
        enableFetch,
        setOrderBy
    ]);
    const { filterValue, selectedFacets, onClear, onFacetFilterClear, onFilterApply, onFilterChange, onFilterClose, loading: facetsLoading } = (0, _useFilter.useFilter)({
        initialValue: (0, _utils.mapFacetFilterFromApi)(data === null || data === void 0 ? void 0 : data.facets),
        headers,
        loadData: loadDataFromFilter,
        pageId,
        appliedFacets,
        setAppliedFacets
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
                hasInitialFacets: hasInitialFacets,
                "data-testid": getTestId(_constants.ACTIONS_ROOT),
                children: [
                    hasInitialFacets ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.FilterWrapper, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FacetFilter.FacetFilter, {
                                value: filterValue,
                                title: translations.filter,
                                isLoading: facetsLoading,
                                settings: {
                                    clearButtonTitle: translations.clear,
                                    submitButtonTitle: translations.apply
                                },
                                onSubmit: onFilterApply,
                                onChange: onFilterChange,
                                onClose: onFilterClose
                            }),
                            selectedFacets.length > 0 && isMobile ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Badge, {
                                color: "primary",
                                badgeContent: selectedFacets.length,
                                max: 99
                            }) : null
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Sorting.Sorting, {
                        value: orderBy,
                        options: mappedOrderByOptions,
                        onChange: onSort
                    })
                ]
            }),
            selectedFacets.length > 0 && !isMobile ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FilterContainerWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FiltersContainer.FiltersContainer, {
                    isLoading: facetsLoading || isRefreshing,
                    selectedItems: selectedFacets,
                    settings: {
                        clearButtonTitle: translations.clearAllFilters
                    },
                    onClear: onClear,
                    onDelete: onFacetFilterClear
                })
            }) : null
        ]
    });
};
exports.Actions = Actions;
